import React from "react";
import * as XLSX from "xlsx";

const ExportTableToExcelButton = ({ data, fileName = "export.xlsx", buttonText = "Export to Excel", className = "btn btn-success" }) => {
  const handleExportToExcel = () => {
    if (!data || data.length === 0) {
      console.error("No data to export.");
      alert("No data available to export.");
      return;
    }

    try {
      const worksheet = XLSX.utils.json_to_sheet(data);
      
      // Apply number formatting to currency columns
      const range = XLSX.utils.decode_range(worksheet['!ref']);
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C }); // Header row
        const cell = worksheet[cellAddress];
        const columnName = cell?.v;
        
        // Format numeric columns (raw numbers)
        if (columnName === 'Amount Disbursed' || columnName === 'Variance') {
          for (let R = range.s.r + 1; R <= range.e.r; ++R) {
            const dataCellAddress = XLSX.utils.encode_cell({ r: R, c: C });
            if (worksheet[dataCellAddress] && worksheet[dataCellAddress].v !== null) {
              worksheet[dataCellAddress].z = '#,##0'; // Number format with commas
            }
          }
        }
        
        // Auto-adjust column widths for better readability
        if (!worksheet['!cols']) worksheet['!cols'] = [];
        worksheet['!cols'][C] = { wch: 20 }; // Default column width
      }

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, fileName);
    } catch (error) {
      console.error("Error exporting to Excel:", error);
      alert("Error exporting to Excel. Please try again.");
    }
  };

  return (
    <button
      onClick={handleExportToExcel}
      className="the-export-excel-button"
    >
      <i className="fas fa-file-excel me-1"></i> {buttonText}
    </button>
  );
};

export default ExportTableToExcelButton;